import { LIST_URL_SPECS, listRedirectPath } from './listUrlState';

export function procurationFeeRedirectPath(id: string): string {
  return listRedirectPath(LIST_URL_SPECS.PROCURATION_FEES, id);
}

export function procurationFeeRuleRedirectPath(id: string): string {
  return listRedirectPath(LIST_URL_SPECS.PROCURATION_FEE_RULES, id);
}
